import { createContext, useContext } from 'react';

export const DarkModeContext = createContext({ mode: 'dark', toggleMode: () => {} });

export const useDarkModeContext = () => useContext(DarkModeContext);
